import React, { useEffect, useState } from 'react';
import './styles.scss';
import { useDisclosure, useMediaQuery } from '@mantine/hooks';
import {
  Badge,
  Box,
  Divider,
  Flex,
  Grid,
  Popover,
  ScrollArea,
  Stack,
  Text,
  TypographyStylesProvider
} from '@mantine/core';
import { CourseItem } from '.';
import CourseCategory from './CourseCategory';
import TargetAudience from './TargetAudience';
import JobBand from './JobBand';
import FacilitatorSection from './FacilitatorSection';
import CourseQuota from './CourseQuota';
import CourseStar from './CourseStar';
import CourseLike from './CourseLike';
import { useHistory } from 'react-router-dom';

import Image from '../../image';
import he from 'he';
import Button from '../../elements/Button';
import NoImage from '../../../assets/icon/illustrations_no-image.svg';
import { useLandingPageConfig } from '../../../hooks/useLandingPageConfig';
import { ApiService } from '../../../constants';

// ...

const EventItem: React.FC<CourseItem> = ({
  id,
  isCarousel,
  urlimage,
  namecourse,
  coursecategory,
  targetaudience,
  spesificjobband,
  quotaavailable,
  fasilitator,
  ratingscore = '0',
  courselike = '0',
  learningobjectives,
  recommendationConfidence,
  tag,
  isPreview,
  breakpoint,
  label,
  footerSection
}) => {
  const { config, setLandingPageConfig, isExpired } = useLandingPageConfig();
  const [defaultImage, setDefaultImage] = useState<string | undefined>();
  useEffect(() => {
    if (!defaultImage && config) {
      const randomIndex = Math.floor(
        Math.random() * config.defaultImage.length
      );
      setDefaultImage(config.defaultImage[randomIndex]?.description);
    }
  }, [config, defaultImage]);

  const imageUrl = urlimage
    ? ApiService.beelajar.getImageMoodle(urlimage)
    : defaultImage;
  const [opened, { open, close }] = useDisclosure(false);
  const router = useHistory();
  const smScreen = useMediaQuery('(max-width: 48em)');

  const [spanSize, setSpanSize] = useState<any>({
    base: 12,
    sm: 6,
    lg: 3,
    xl: 4
  });
  const publishSize = { base: 12, sm: 6, lg: 3 };
  const previewMobileSize = { base: 12 };
  const previewDesktopSize = { base: 12, sm: 6, lg: 4, xl: 4 };
  const previewModalSize = { base: 12, sm: 6, lg: 3 };
  useEffect(() => {
    if (isPreview) {
      if (breakpoint === 'mobile') {
        setSpanSize(previewMobileSize);
      } else if (breakpoint === 'desktop') {
        setSpanSize(previewDesktopSize);
      } else {
        setSpanSize(previewModalSize);
      }
    } else {
      setSpanSize(publishSize);
    }
  }, [isPreview, breakpoint]);

  const renderHtml = () => {
    if (!learningobjectives) return null;

    const decodedHtml = he.decode(learningobjectives);
    return <div dangerouslySetInnerHTML={{ __html: decodedHtml }} />;
  };

  const renderItem = () => {
    return (
      <Popover
        width={300}
        position="right"
        withArrow
        shadow="xl"
        radius={12}
        arrowSize={16}
        arrowOffset={0}
        opened={opened}
      >
        <Popover.Target>
          <div
            className="container_event_item"
            onMouseEnter={() => open()}
            onMouseLeave={() => close()}
          >
            <div
              className="container_event_item__image_header"
              style={{
                cursor: 'pointer'
              }}
              onClick={() => {
                router.push(`/event/${id}`);
              }}
            >
              <Image
                placeholder={NoImage}
                src={imageUrl || defaultImage}
                style={{
                  width: '100%',
                  height: '120px',
                  objectFit: 'cover',
                  borderRadius: '10px 10px 0 0'
                }}
                alt={namecourse}
              />
            </div>
            {label}
            <Stack flex={1} gap={10} justify="space-between">
              <CourseCategory data={coursecategory} noTag />
              <span
                style={{
                  cursor: 'pointer'
                }}
                onClick={() => {
                  router.push(`/event/${id}`);
                }}
              >
                <Text fz={14} fw={600}>
                  {namecourse}
                </Text>
              </span>

              <TargetAudience data={targetaudience} />
              <JobBand data={spesificjobband} />
              <Flex justify={'space-between'}>
                <FacilitatorSection facilitators={fasilitator} />
                <CourseQuota quota={parseInt(quotaavailable)} />
              </Flex>
              <Flex justify={'space-between'}>
                <CourseStar rating={ratingscore} />
                <CourseLike likes={parseInt(courselike)} />
              </Flex>
              <CourseCategory data={tag} color="cyan" />
              {footerSection}

              {!ApiService.icdc.auth.userAuth.startsWith(
                'https://api.apps.binus.ac.id/beelajar2/'
              ) && (
                <Flex justify={'end'}>
                  <Badge variant="outline" color="gray" radius="sm" fz={10}>
                    Confidence: {recommendationConfidence}
                  </Badge>
                </Flex>
              )}
            </Stack>
          </div>
        </Popover.Target>

        <Popover.Dropdown
          onMouseEnter={() => open()}
          onMouseLeave={() => close()}
        >
          <Box component="div" h={300}>
            <ScrollArea h={250} mb={4}>
              <Stack flex={1} gap={8} justify="space-between">
                <span
                  style={{
                    cursor: 'pointer'
                  }}
                  onClick={() => {
                    router.push(`/event/${id}`);
                  }}
                >
                  <Text fz={18} fw={700}>
                    {namecourse}
                  </Text>
                </span>
                <Divider my={4} />
                <Text fz={14} fw={600}>
                  Learning Objectives
                </Text>
                <TypographyStylesProvider p={0} m={0}>
                  {renderHtml()}
                </TypographyStylesProvider>
              </Stack>
            </ScrollArea>
            <Button
              onClick={() => {
                router.push(`/event/${id}`);
              }}
              full
            >
              See Details
            </Button>
          </Box>
        </Popover.Dropdown>
      </Popover>
    );
  };

  if (isCarousel === 'Y') {
    return <>{renderItem()}</>;
  }

  return <Grid.Col span={spanSize}>{renderItem()}</Grid.Col>;
};

export default EventItem;
